// LINE 約診提醒（當天、一天前、兩天前、週五提醒週一）可選的時段：07:00～19:00 每 30 分鐘，共 25 個。
// crm-tw 的 App\Support\LineReminderTimeSlots 用同一份清單驗證存檔，兩邊要一起改。
const FIRST_MINUTE = 7 * 60
const LAST_MINUTE = 19 * 60
const STEP_MINUTES = 30

function toTime(minutes) {
  const hh = String(Math.floor(minutes / 60)).padStart(2, '0')
  const mm = String(minutes % 60).padStart(2, '0')
  return `${hh}:${mm}`
}

const times = []
for (let minutes = FIRST_MINUTE; minutes <= LAST_MINUTE; minutes += STEP_MINUTES) {
  times.push(toTime(minutes))
}

export const LINE_REMIND_TIME_OPTIONS = [
  ...times.map(time => ({ text: time, value: time })),
  { text: '不通知', value: null },
]
